module.exports = require("redux-immutable");


//////////////////
// WEBPACK FOOTER
// external "redux-immutable"
// module id = 381
// module chunks = 0